import { render } from "./LbrxSideMenuIcons.vue?vue&type=template&id=a7ddcb66"
import script from "./LbrxSideMenuIcons.vue?vue&type=script&lang=js"
export * from "./LbrxSideMenuIcons.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__